module.exports = __webpack_public_path__ + "stylesheets/main-page_8329411c2916d406845483d22ea05fcb.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/main-page.less
// module id = dJ+1
// module chunks = 153